import { connect } from 'react-redux'
import { changeDocumentType } from '../../actions/TypesAction'
import { getDocuments } from '../../actions/DocumentAction'
import SearchForm from '../presentation/SearchForm'

const mapStateToProps = (state, ownProps) => {
  const types = state.types;
  console.log("MapStateToProps for SearchFormView!!!!");
  const o = {
    documentTypes: types.searchForm.documentTypes,
    types: types.searchForm != null? types.searchForm.types : [],
    fields: types.searchForm != null? types.searchForm.fields : [],
    selected: types.searchForm != null? types.searchForm.selected : 0,
    form: types.searchForm != null? types.searchForm.form : [],
    strings: state.i18.strings
  }
  console.log("Form:" + o.form);
  return o;
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    changeDocumentType: docType => {
      console.log("CHANGE DOCTYPE:" + typeof(docType));
      dispatch(changeDocumentType(docType))
    },
    searchDocuments: (docType, attributes) => {
      console.log("SearchDocuments");
      dispatch(getDocuments(docType, attributes))
    }
  }
}

const SearchFormView = connect(mapStateToProps, mapDispatchToProps)(SearchForm)

export default SearchFormView;